import { Formats } from '@/components/inputs/upload/formats';

export const formats = [Formats.CSV, Formats.XLS, Formats.XLSX, Formats.TXT, Formats.PDF];
